function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (word) {
      pug_html = pug_html + "\u003Cdiv class=\"block-md block-dk\"\u003E";
// iterate word
;(function(){
  var $$obj = word;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var letter = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv" + (" class=\"letter btn btn-solid\""+pug_attr("data-letter", letter.toLowerCase(), true, true)) + "\u003E" + (null == (pug_interp = letter) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var letter = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv" + (" class=\"letter btn btn-solid\""+pug_attr("data-letter", letter.toLowerCase(), true, true)) + "\u003E" + (null == (pug_interp = letter) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "word" in locals_for_with ?
        locals_for_with.word :
        typeof word !== 'undefined' ? word : undefined));
    ;;return pug_html;};module.exports=template;